import React, { useState } from "react";
import {
  Modal,
  Input,
  Button,
  Select,
  Typography,
  Form,
  message,
  Upload,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";

const { Title } = Typography;
const { Option } = Select;

const AddUserModal = ({ visible, onCancel }) => {
  const [fileList, setFileList] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const handleSubmit = async (values) => {
    //  Validate Email Format
    if (!emailRegex.test(values.userId.toLowerCase())) {
      message.error("Enter a valid Email");
      return;
    }

    //  Create FormData (to handle file upload)
    const formData = new FormData();
    formData.append("userName", values.userName);
    formData.append("userId", values.userId.toLowerCase());
    formData.append("password", values.password);

    //  Append multiple roles as JSON string (backend should parse it)
    formData.append("roles", JSON.stringify(values.roles));

    //  Add signature if present
    if (fileList.length > 0) {
      formData.append("signature", fileList[0].originFileObj);
    }

    try {
      
      const response = await axios.post(
        `${apiUrl}/api/auth/registerUser`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      
      if (response.data.success) {
        message.success("User added successfully!");
        onCancel(); // Close modal
      } else {
        message.error(response.data.message || "Failed to add user.");
      }
    } catch (error) {
      message.error("Some error occurred.");
    }
  };

  return (
    <Modal
      title="Add New User"
      open={visible}
      onCancel={onCancel}
      footer={null}
    >
      <Form layout="vertical" onFinish={handleSubmit}>
        {/* User Name */}
        <Form.Item
          label="User Name"
          name="userName"
          rules={[{ required: true, message: "Please input the user name!" }]}
        >
          <Input placeholder="Enter user name" />
        </Form.Item>

        {/* User Email */}
        <Form.Item
          label="User Email"
          name="userId"
          rules={[{ required: true, message: "Please input the user email!" }]}
        >
          <Input placeholder="user@example.com" />
        </Form.Item>

        {/* Password */}
        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Please input the password!" }]}
        >
          <Input.Password placeholder="Enter password" />
        </Form.Item>

        {/* Multi-Select Role */}
        <Form.Item
          label="Roles"
          name="roles"
          rules={[{ required: true, message: "Please select at least one role!" }]}
        >
          <Select
            mode="multiple" //  Enables multi-select
            placeholder="Select one or more roles"
            allowClear
          >
            <Option value="SUPER_ADMIN">Super Admin</Option>
            <Option value="ACCOUNT_ADMIN">Account Admin</Option>
            <Option value="AUDIT_ADMIN">Audit Admin</Option>
            <Option value="AUDITOR">Auditor</Option>
          </Select>
        </Form.Item>

        {/* Signature Upload */}
        <Form.Item
          label="Signature"
          name="signature"
          rules={[{ required: true, message: "Please upload the signature!" }]}
        >
          <Upload
            beforeUpload={() => false} // Prevent auto-upload
            fileList={fileList}
            onChange={({ fileList }) => setFileList(fileList)}
            accept="image/*"
          >
            <Button icon={<UploadOutlined />}>Upload Signature</Button>
          </Upload>
        </Form.Item>

        {/* Submit Button */}
        <Form.Item>
          <Button type="primary" htmlType="submit" className="w-full">
            Add User
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddUserModal;
